// ==========================================================================
// Squarebit Store - Copyright (c) 2026 Squarebit LLC. All rights reserved.
// Proprietary and confidential. Not for redistribution.
//
// Squarebit Eye product pages / widget (store front end). The Eye software
// itself is licensed separately under the Squarebit Eye End User License
// Agreement: https://store.squarebitstudios.com/squarebit-eye/eula
// ==========================================================================

import React from 'react';
import { ProductChangelog } from '../common/components/product-changelog.component';
import pkg from '../../../package.json';

const EyeChangelog: React.FC = () => (
  <ProductChangelog
    productName="Squarebit Eye"
    version={
      (pkg as { squarebitEye?: { version?: string } }).squarebitEye?.version ??
      '0.0.0'
    }
    mdPath="/changelog-squarebit-eye.md"
    publicRepo={null}
    showDownloadLinks={false}
  />
);

export default EyeChangelog;
